import clsx from 'clsx';
import React from 'react';
import type { ListComplexDropdownProps } from './types';
import useListComplexDropdown from './useListComplexDropdown';

/**
 * ListComplexDropdown — v2 molecule.
 *
 * Lista de acciones con contenido rico (izquierda / centro / derecha) para el
 * interior de un dropdown. Migración TypeScript del v1. Cada fila replica el
 * marcado de `ItemComplexList` pero se renderiza como `<li role="menuitem">`
 * dentro de un `<ul role="menu">` (corrige el `<div>`-hijo-de-`<ul>` del v1) y
 * participa en la navegación por teclado (flechas, Home/End, Enter/Space).
 */
function ListComplexDropdown({
  ariaLabel,
  isEllipsis = false,
  items = [],
  onClick = () => {},
  shouldAutoFocusFirstItem = false,
}: Readonly<ListComplexDropdownProps>): JSX.Element {
  const { getItemProps, getMenuProps, resolveItem, resolvedAriaLabel } = useListComplexDropdown({
    ariaLabel,
    items,
    onClick,
    shouldAutoFocusFirstItem,
  });

  return (
    <ul aria-label={resolvedAriaLabel} className="list-complex-dropdown" {...getMenuProps()}>
      {items.map((item, index) => {
        const { center, className, guid, left, previewContent, restProps, right } = resolveItem(item);

        return (
          <li className="list-complex-dropdown__item" key={guid} {...restProps} {...getItemProps(index)}>
            <div className={clsx('item-complex-list', className)}>
              <div className="item-complex-list__left">
                {left && <div className="item-complex-list__left-children">{left}</div>}
                <div className={clsx('item-complex-list__center', { 'list__center__ellipsis': isEllipsis })}>{center}</div>
              </div>
              <div className="item-complex-list__right">{right}</div>
            </div>
            {previewContent && <>{previewContent}</>}
          </li>
        );
      })}
    </ul>
  );
}

export default ListComplexDropdown;
